import { FC } from 'react';
import { ReportPreviewStatus } from '../../../../../states/statusWorker/statusWorker.state';
import { styled } from '@mui/material/styles';
import { Print as PrintIcon } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';

export const PrintButton: FC<IPrintButtonProps> = ({ onClick, status }) => {
  const isPrintable =
    status !== ReportPreviewStatus.disabled && status !== ReportPreviewStatus.error;

  if (status === ReportPreviewStatus.loading) {
    return <CircularProgress size={20} />;
  }

  if (!isPrintable) {
    return <SPrintIcon state='disabled' />;
  }

  return <SPrintIcon onClick={onClick} />;
};

export const SPrintIcon = styled(PrintIcon)<{ state?: 'disabled' }>(({ state, theme }) => ({
  width: '20px',
  height: '20px',
  color: theme.palette.grey['600'],
  cursor: 'pointer',
  ...(state === 'disabled' && {
    opacity: 0.3,
    cursor: 'default',
  }),
}));

interface IPrintButtonProps {
  onClick: () => void;
  status: ReportPreviewStatus;
}
